import { render, staticRenderFns } from "./Litigation.vue?vue&type=template&id=c2441d8e&scoped=true"
import script from "./Litigation.vue?vue&type=script&lang=js"
export * from "./Litigation.vue?vue&type=script&lang=js"
import style0 from "./Litigation.vue?vue&type=style&index=0&id=c2441d8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2441d8e",
  null
  
)

export default component.exports